export function addProduct (state, { competitionId, product }) {
	const exsistingCompetitionIndex = state.competitions.findIndex(competition => competition.id === competitionId);

	if (exsistingCompetitionIndex >= 0) {
		return state.competitions[exsistingCompetitionIndex].products.push(product);
	}
}
